export default __webpack_public_path__ + "static/media/bg-home.b883c288.webp";